import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import scanStore from "@/store/scanStore";

const ChipNotConfigured = () => {
  const [mounted, setMounted] = useState(false);
  const navigate = useNavigate();
  const { serial, company } = scanStore();

  useEffect(() => {
    const t = setTimeout(() => setMounted(true), 50);
    return () => clearTimeout(t);
  }, []);

  const color = "#f59e0b";
  const bgGlow = "rgba(245, 158, 11, 0.08)";
  const bgAccent = "rgba(245, 158, 11, 0.04)";

  return (
    <div
      style={{
        minHeight: "100dvh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "24px 16px",
        background: "#fafbfc",
        fontFamily: "'Outfit', 'Segoe UI', system-ui, -apple-system, sans-serif",
      }}
    >
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700&family=JetBrains+Mono:wght@400;500&display=swap');

        @keyframes fadeUp {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes pulse {
          0%, 100% { opacity: 0.4; }
          50% { opacity: 1; }
        }
        @keyframes iconBreathe {
          0%, 100% { transform: scale(1); }
          50% { transform: scale(1.05); }
        }
        @keyframes shimmer {
          0% { background-position: -200% 0; }
          100% { background-position: 200% 0; }
        }
        @keyframes ringPulse {
          0% { transform: scale(0.8); opacity: 0.6; }
          100% { transform: scale(1.6); opacity: 0; }
        }

        .nc-card {
          width: 100%;
          max-width: 420px;
          background: #ffffff;
          border-radius: 24px;
          border: 1px solid #e8ecf1;
          box-shadow:
            0 1px 3px rgba(0,0,0,0.04),
            0 8px 32px rgba(0,0,0,0.06);
          overflow: hidden;
          opacity: 0;
          animation: fadeUp 0.6s cubic-bezier(0.16, 1, 0.3, 1) forwards;
        }

        .nc-header {
          position: relative;
          padding: 40px 32px 32px;
          text-align: center;
          overflow: hidden;
        }

        .nc-header::before {
          content: '';
          position: absolute;
          top: 0; left: 0; right: 0;
          height: 4px;
          background: ${color};
        }

        .nc-header::after {
          content: '';
          position: absolute;
          top: 0; left: 0; right: 0; bottom: 0;
          background: radial-gradient(ellipse at top, ${bgGlow}, transparent 70%);
          pointer-events: none;
        }

        .nc-icon-container {
          position: relative;
          width: 88px;
          height: 88px;
          margin: 0 auto 20px;
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1;
        }

        .nc-icon-bg {
          position: absolute;
          inset: 0;
          border-radius: 50%;
          background: ${bgAccent};
          border: 1.5px solid ${color}18;
          animation: iconBreathe 3s ease-in-out infinite;
        }

        .nc-icon-ring {
          position: absolute;
          inset: -4px;
          border-radius: 50%;
          border: 1.5px solid ${color}20;
          animation: ringPulse 2.5s ease-out infinite;
        }

        .nc-icon-inner {
          position: relative;
          z-index: 1;
          opacity: 0;
          animation: fadeUp 0.5s 0.2s cubic-bezier(0.16, 1, 0.3, 1) forwards;
        }

        .nc-badge {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          padding: 5px 14px;
          border-radius: 100px;
          font-family: 'JetBrains Mono', monospace;
          font-size: 11px;
          font-weight: 500;
          letter-spacing: 1.5px;
          color: ${color};
          background: ${bgAccent};
          border: 1px solid ${color}20;
          margin-bottom: 16px;
          position: relative;
          z-index: 1;
          opacity: 0;
          animation: fadeUp 0.5s 0.3s cubic-bezier(0.16, 1, 0.3, 1) forwards;
        }

        .nc-badge-dot {
          width: 6px;
          height: 6px;
          border-radius: 50%;
          background: ${color};
          animation: pulse 2s ease-in-out infinite;
        }

        .nc-title {
          font-size: 22px;
          font-weight: 700;
          color: #0f172a;
          margin: 0 0 10px;
          line-height: 1.3;
          position: relative;
          z-index: 1;
          opacity: 0;
          animation: fadeUp 0.5s 0.35s cubic-bezier(0.16, 1, 0.3, 1) forwards;
        }

        .nc-desc {
          font-size: 14.5px;
          font-weight: 400;
          color: #64748b;
          line-height: 1.65;
          margin: 0;
          position: relative;
          z-index: 1;
          opacity: 0;
          animation: fadeUp 0.5s 0.4s cubic-bezier(0.16, 1, 0.3, 1) forwards;
        }

        .nc-details {
          padding: 0 24px 24px;
          opacity: 0;
          animation: fadeUp 0.5s 0.5s cubic-bezier(0.16, 1, 0.3, 1) forwards;
        }

        .nc-detail-box {
          background: #f8fafc;
          border: 1px solid #e8ecf1;
          border-radius: 14px;
          padding: 16px 18px;
          display: flex;
          flex-direction: column;
          gap: 10px;
        }

        .nc-detail-row {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 12px;
        }

        .nc-detail-label {
          font-size: 12.5px;
          color: #94a3b8;
          font-weight: 500;
          white-space: nowrap;
        }

        .nc-detail-value {
          font-family: 'JetBrains Mono', monospace;
          font-size: 12.5px;
          color: #334155;
          font-weight: 500;
          text-align: right;
          word-break: break-all;
        }

        .nc-detail-divider {
          height: 1px;
          background: #e8ecf1;
          margin: 2px 0;
        }

        .nc-warning-box {
          margin: 0 24px 20px;
          padding: 14px 16px;
          background: rgba(245, 158, 11, 0.06);
          border: 1px solid rgba(245, 158, 11, 0.2);
          border-radius: 12px;
          display: flex;
          align-items: flex-start;
          gap: 10px;
          opacity: 0;
          animation: fadeUp 0.5s 0.52s cubic-bezier(0.16, 1, 0.3, 1) forwards;
        }

        .nc-warning-text {
          font-size: 13px;
          color: #92400e;
          line-height: 1.6;
          font-weight: 400;
        }

        .nc-actions {
          padding: 0 24px 28px;
          display: flex;
          flex-direction: column;
          gap: 10px;
          opacity: 0;
          animation: fadeUp 0.5s 0.6s cubic-bezier(0.16, 1, 0.3, 1) forwards;
        }

        .nc-btn-primary {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          width: 100%;
          padding: 14px 20px;
          border-radius: 14px;
          border: none;
          font-family: 'Outfit', sans-serif;
          font-size: 15px;
          font-weight: 600;
          color: #fff;
          background: ${color};
          cursor: pointer;
          transition: all 0.2s ease;
          position: relative;
          overflow: hidden;
        }

        .nc-btn-primary::after {
          content: '';
          position: absolute;
          inset: 0;
          background: linear-gradient(90deg, transparent, rgba(255,255,255,0.12), transparent);
          background-size: 200% 100%;
          animation: shimmer 2.5s ease-in-out infinite;
        }

        .nc-btn-primary:hover {
          transform: translateY(-1px);
          box-shadow: 0 4px 16px ${color}40;
        }

        .nc-btn-primary:active {
          transform: translateY(0);
        }
      `}</style>

      <div className="nc-card" style={{ animationDelay: mounted ? "0s" : "0.1s" }}>
        {/* Header */}
        <div className="nc-header">
          <div className="nc-icon-container">
            <div className="nc-icon-ring" />
            <div className="nc-icon-bg" />
            <div className="nc-icon-inner">
              <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
                <rect x="6" y="6" width="36" height="36" rx="8" stroke="#f59e0b" strokeWidth="2.5" />
                {/* Checkmark nhỏ góc phải */}
                <circle cx="35" cy="13" r="6" fill="#10b981" />
                <path d="M32 13l2 2 4-4" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                {/* Dấu chấm hỏi giữa */}
                <path d="M24 20c0-2.5 2-4 4-3.5" stroke="#f59e0b" strokeWidth="2.2" strokeLinecap="round" />
                <circle cx="24" cy="31" r="1.5" fill="#f59e0b" />
                <path d="M24 23v5" stroke="#f59e0b" strokeWidth="2.2" strokeLinecap="round" />
              </svg>
            </div>
          </div>

          <div className="nc-badge">
            <span className="nc-badge-dot" />
            ACTIVATED · NOT CONFIGURED
          </div>

          <h1 className="nc-title">Chip chưa được cấu hình</h1>
          <p className="nc-desc">Chip đã được kích hoạt thành công nhưng chưa có nội dung để hiển thị.</p>
        </div>

        {/* Warning box */}
        <div className="nc-warning-box">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" style={{ flexShrink: 0, marginTop: 1 }}>
            <path
              d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"
              stroke="#f59e0b"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <line x1="12" y1="9" x2="12" y2="13" stroke="#f59e0b" strokeWidth="2" strokeLinecap="round" />
            <line x1="12" y1="17" x2="12.01" y2="17" stroke="#f59e0b" strokeWidth="2" strokeLinecap="round" />
          </svg>
          <p className="nc-warning-text">
            Chủ sở hữu chip cần đăng nhập và hoàn tất cấu hình nội dung để chip có thể hoạt động.
          </p>
        </div>

        {/* Details */}
        <div className="nc-details">
          <div className="nc-detail-box">
            {serial && (
              <>
                <div className="nc-detail-row">
                  <span className="nc-detail-label">Serial</span>
                  <span className="nc-detail-value">{serial}</span>
                </div>
                <div className="nc-detail-divider" />
              </>
            )}
            <div className="nc-detail-row">
              <span className="nc-detail-label">Trạng thái chip</span>
              <span className="nc-detail-value" style={{ color: "#10b981" }}>
                ACTIVATED
              </span>
            </div>
            <div className="nc-detail-divider" />
            <div className="nc-detail-row">
              <span className="nc-detail-label">Cấu hình</span>
              <span className="nc-detail-value" style={{ color: "#f59e0b" }}>
                Chưa hoàn tất
              </span>
            </div>
            {company?.name && (
              <>
                <div className="nc-detail-divider" />
                <div className="nc-detail-row">
                  <span className="nc-detail-label">Doanh nghiệp</span>
                  <span className="nc-detail-value">{company.name}</span>
                </div>
              </>
            )}
          </div>
        </div>

        {/* Actions */}
        <div className="nc-actions">
          <button className="nc-btn-primary" onClick={() => navigate("/login")}>
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4" />
              <polyline points="10 17 15 12 10 7" />
              <line x1="15" y1="12" x2="3" y2="12" />
            </svg>
            Đăng nhập để cấu hình
          </button>
        </div>
      </div>
    </div>
  );
};

export default ChipNotConfigured;
